import { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import PropTypes from 'prop-types';
import { EntitlementMapper } from '@contently/entitlements';

import { Toggleable } from '../toggleable';
import { ComponentError } from '../../internal';

export class Can extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabled: false,
    };
  }

  componentDidMount() {
    this.checkIsEntitled();
  }

  componentDidUpdate(prevProps) {
    const { permissionsMap } = this.props;
    if (!_.isEqual(prevProps.permissionsMap, permissionsMap)) {
      this.checkIsEntitled();
    }
  }

  checkIsEntitled = () => {
    const { permission, permissionsMap } = this.props;
    const mappedEntitlements = EntitlementMapper.load(permissionsMap);
    mappedEntitlements.isEntitled(permission).then((result) => {
      this.setState({
        enabled: result,
      });
    });
  };

  enabledValue() {
    const { enabled } = this.state;

    return enabled;
  }

  render() {
    const { children, permission, permissionsMap } = this.props;

    if (!permissionsMap) {
      return <ComponentError>Entitlements is required</ComponentError>;
    }
    if (!permission) {
      return <ComponentError>No permission was specified</ComponentError>;
    }

    return <Toggleable show={this.enabledValue()}>{children}</Toggleable>;
  }
}

const mapStateToProps = (state) => {
  const { permissionsMap } = state.entitlements;
  return {
    permissionsMap,
  };
};

Can.propTypes = {
  permissionsMap: PropTypes.shape({}).isRequired,
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

export default connect(mapStateToProps)(Can);
